module.exports = __webpack_public_path__ + "2ba264b5ec2d832c0e2aa4d2c7a84278.svg";